module.exports = __webpack_public_path__ + "img/files.b0613501.svg";